import './CheckBox.css';
import React, { ChangeEvent, ReactNode } from 'react';
import { FieldErrors, FieldValues } from 'react-hook-form';
import { cx } from '#/Scripts/utilities/cx';
import { InputError } from '#sign-up/components/shared/InputError';

type Props<FormValues extends FieldValues = FieldValues> = React.InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  id: string;
  label: ReactNode;
  inline?: boolean;
  disabled?: boolean;
  errors?: FieldErrors<FormValues>;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

const CheckBox = React.forwardRef<HTMLInputElement, Props>(
  ({ name, id, label, inline, errors, onChange, disabled = false, className = '', ...props }: Props, ref) => {
    const checkbox = (
      <input
        ref={ref}
        className={cx('styled-checkbox', inline && 'styled-checkbox-inline')}
        id={id}
        name={name}
        type="checkbox"
        disabled={disabled}
        onChange={(e) => {
          onChange?.(e);
        }}
        aria-invalid={errors?.[name] ? 'true' : 'false'}
        aria-describedby={`error-${name}`}
        {...props}
      />
    );
    return (
      <div className={cx('checkbox-input', errors?.[name] && 'error', className)}>
        <div className="checkbox-main">
          {inline ? (
            <label htmlFor={id}>
              {checkbox}
              {label}
            </label>
          ) : (
            <>
              {checkbox}
              <label htmlFor={id}>{label}</label>
            </>
          )}
        </div>
        <InputError error={errors?.[name]} name={name} />
      </div>
    );
  }
);

CheckBox.displayName = 'CheckBox';

export default CheckBox;
